import { render } from "./CopyActivityModal.vue?vue&type=template&id=5d58b7ae&scoped=true"
import script from "./CopyActivityModal.vue?vue&type=script&lang=js"
export * from "./CopyActivityModal.vue?vue&type=script&lang=js"

import "./CopyActivityModal.vue?vue&type=style&index=0&id=5d58b7ae&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d58b7ae"]])

export default __exports__